<template>
  <!-- <div class="footer">
        <div class="container">
            <div class="row">
                <div class="col-md-6 offset-md-3">
                    <ul>
                        <li>版權所有：嘉義縣政府農業處</li>
                        <li>機關地址：61249嘉義縣太保市祥和一路東段一號</li>
                        <li>聯絡電話：(05)3620123分機8992</li>
                        <li>服務傳真：(05)3621297</li>
                        <li>服務時間：週一至週五 上午08:00-12:00 下午13:00-17:00</li>
                        <li>累計瀏覽人次：{{this.View}}</li>
                    </ul>
                </div>
            </div>
        </div>
    </div> -->
  <div class="footer">
    <b-container fluid>
      <b-row>
        <b-col lg="auto" md="4" sm="6">版權所有：嘉義縣政府農業處</b-col>
        <b-col lg="auto" md="4" sm="6"
          >機關地址：61249嘉義縣太保市祥和一路東段一號</b-col
        >
        <b-col lg="auto" md="4" sm="6">聯絡電話：(05)3620123分機8992</b-col>
        <b-col lg="auto" md="4" sm="6">服務傳真：(05)3621297</b-col>
        <b-col lg="auto" md="4" sm="6">客服專線：(04)24516669分機709</b-col>
      </b-row>
      <b-row>
        <b-col lg="auto" md="4" sm="6"
          >服務時間：週一至週五 上午08:00-12:00 下午13:00-17:00</b-col
        >
        <b-col lg="auto" md="4" sm="6">累計瀏覽人次：{{ this.View }}</b-col>
      </b-row>
    </b-container>
  </div>
</template>
<script>
export default {
  name: "Footer",
  data() {
    return {
      View: "",
      apiGetView: (data) => this.userRequest.post("API/Default/GetView", data),
      apiSetView: (data) => this.userRequest.post("API/Default/SetView", data),
    };
  },
  components: {},
  updated() {},
  mounted() {
    this.FunctionToken(this.GetView, {});
    var viewDate = sessionStorage.getItem("viewDate");
    var date = new Date().toLocaleString("zh-TW", { timeZone: "Asia/Taipei" });
    date = date.split(" ")[0];
    if (!viewDate || viewDate != date) {
      sessionStorage.setItem("viewDate", date);
      this.FunctionToken(this.SetView, {});
    }
  },
  methods: {
    GetView(data) {
      this.apiGetView(data)
        .then((res) => {
          const json = JSON.parse(res.data);
          if (json.Status) {
            var jsonData = JSON.parse(json.Data);
            this.View = jsonData.COUNT;
          }
        })
        .catch((err) => {
          console.warn(err);
        });
    },
    SetView(data) {
      this.apiSetView(data)
        .then((res) => {
          const json = JSON.parse(res.data);
          if (json.Status) {
            var jsonData = JSON.parse(json.Data);
            this.View = jsonData.COUNT;
          }
        })
        .catch((err) => {
          console.warn(err);
        });
    },
  },
};
</script>
<style lang="scss">
.logo {
  height: 48px;
}
</style>
